module.exports = __webpack_public_path__ + "img/transnautica_2.7fc57b66.png";